/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IRingConfiguratorData } from './ring-configurator.data';
import { IRingConfiguratorProps } from './ring-configurator.props.autogenerated';
import {
    addLinesAsync,
    createGetByCustomerInput,
    getByCustomerAsync
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/CommerceListsDataActions.g';
import axios from 'axios';
import { getByIdAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import {
    createB2CCartServiceAsync,
    createSavedDesignsAsync,
    getB2BCustomerIdAsync,
    getBMAStockistAsync,
    getRequestOrderAsync,
    getSavedDesignsAsync,
    updateCommerceListAsync
} from '../../dataActions/DataActionExtension.g';
import { addCartLinesAsync, updateCartLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { Button } from '@msdyn365-commerce-modules/utilities';
import { CommerceListLine } from '@msdyn365-commerce/retail-proxy';
import { when } from 'mobx';
import { getCartState } from '@msdyn365-commerce/global-state';

export interface IRingConfiguratorViewProps extends IRingConfiguratorProps<IRingConfiguratorData> {
    _renderPopUp?: any;
    ringConfiguratorOfflinePopUp?: any;
}

/**
 *
 * RingConfigurator component
 * @extends {React.PureComponent<IRingConfiguratorProps<IRingConfiguratorData>>}
 */
class RingConfigurator extends React.PureComponent<IRingConfiguratorProps<IRingConfiguratorData>, any> {
    private addEvent = new Event('addEvent', { bubbles: true, cancelable: true, composed: false });
    private metrixConfiguratorInitializedHandler: ((ev: any) => void) | undefined;
    private hasRegisteredSignInListener = false;
    constructor(props: any) {
        super(props);
        this.state = {
            containerId: '',
            changesSaved: false,
            productId: Number(this.props.context.request.urlTokens.recordId),
            mode: '',
            isBMAProduct: false,
            snapShotId: '',
            recordId: '',
            requestOrderId: '',
            lineId: '',
            showPopUp: false,
            bmaConfigurationIsNotValid: false,
            bmaRetailStockistInfo: undefined,
            isBmaDown: false,
            isUpdateCart: false
        };
    }

    public componentDidMount() {
        const params = new URLSearchParams(this.props.context.request.url.requestUrl.search);
        if (params.has('bmaIsDown')) {
            this.setState({ isBMAProduct: false });
        } else if (params.has('recordId')) {
            // check url has recordId...
            const recordId = params.get('recordId');
            void this.loadSnapShotIdWithSavedDesignRecord(recordId);
        } else if (params.has('requestOrderId') && params.has('lineId')) {
            // check url has requestOrderId && line Id...
            const requestOrderId = params.get('requestOrderId');
            const lineId = params.get('lineId');
            void this.loadSnapShotIdWithRequestOrderRecord(requestOrderId, lineId);
        } else if (params.has('wishListItemSnapShotId') && params.has('lineId')) {
            // check url has wishListItemSnapShotId...
            const wishListItemSnapShotId = params.get('wishListItemSnapShotId');
            const lineId = params.get('lineId');
            void this.loadSnapShotIdWithwishListItem(wishListItemSnapShotId, lineId);
        } else if (params.has('cartLineItemSnapShotId') && params.has('lineId')) {
            // check url has wishListItemSnapShotId...
            const cartLineItemSnapShotId = params.get('cartLineItemSnapShotId');
            const lineId = params.get('lineId');
            when(
                () => {
                    return !!(this.props.data.cart && this.props.data.cart.result);
                },
                () => {
                    void this.loadSnapShotIdWithCartLineItem(cartLineItemSnapShotId, lineId);
                }
            );
        } else {
            // check and set snapShot id ...
            void this.loadSnapShotId();
        }
        console.log('componentDidMount ', new Date());
    }

    public componentDidUpdate(
        prevProps: Readonly<IRingConfiguratorProps<IRingConfiguratorData>>,
        prevState: Readonly<any>,
        snapshot?: any
    ): void {
        if (prevState.snapShotId !== this.state.snapShotId) {
            // if (!window['beforeunload']) {
            //     window.addEventListener('beforeunload', e => {
            //         if (this.state.changesSaved) {
            //             const confirmationMessage =
            //                 'It looks like you have been editing something. ' + 'If you leave before saving, your changes will be lost.';
            //             (e || window.event).returnValue = confirmationMessage;
            //             return confirmationMessage;
            //         }
            //         return null;
            //     });
            // }
            // if snapShotId exist we are applicable to Initialize RingConfigurator....
            void this.configuratorInitialized();
            console.log('componentDidUpdate', new Date());
        }
    }

    private readonly loadSnapShotIdFromProduct = async () => {
        const productInfo: any = await getByIdAsync(
            {
                callerContext: this.props.context.actionContext
            },
            this.state.productId,
            this.props.context.actionContext.requestContext.apiSettings.channelId
        );
        const currentSnapShotObj = productInfo.ExtensionProperties.find((e: any) => {
            return e.Key === 'AAA_BMASNAPSHOTID';
        });
        if (currentSnapShotObj && currentSnapShotObj.Value && currentSnapShotObj.Value.StringValue) {
            this.setState({
                snapShotId: currentSnapShotObj.Value.StringValue,
                isBMAProduct: true
            });
        }
    };

    private readonly loadSnapShotId = () => {
        // case if snapShotInfo is present in cookies for the loaded product...
        const cSnapShotInfo = this.props.context.request.cookies.get<any>('snapShotInfo');
        console.log('snapShotInfo read form loadSnapShotId ', new Date());
        console.log('snapShotInfo name ', cSnapShotInfo.name);
        console.log('snapShotInfo status ', cSnapShotInfo.status);
        console.log('snapShotInfo value ', cSnapShotInfo.value);
        console.log(
            'snapShotInfo condition ',
            cSnapShotInfo.name === 'snapShotInfo' && cSnapShotInfo.status === 'FOUND' && cSnapShotInfo.value
        );
        if (cSnapShotInfo.name === 'snapShotInfo' && cSnapShotInfo.status === 'FOUND' && cSnapShotInfo.value) {
            if (cSnapShotInfo.value.productId === this.state.productId) {
                this.setState({ snapShotId: cSnapShotInfo.value.snapShotId, isBMAProduct: true });
                console.log('snapShotInfo Clean form loadSnapShotId ', new Date());
                this.props.context.request.cookies.set<string>('snapShotInfo', '');
            } else {
                // case snapShotInfo is present in cookies but not for the same product...
                // so that case get and set SnapShotId form product get ...
                console.log('load ori. when product mismatch form loadSnapShotId ', new Date());
                void this.loadSnapShotIdFromProduct();
            }
        } else {
            // case if snapShotInfo is not present in cookies for the loaded product...
            // so that case get and set SnapShotId form product get ...
            console.log('load ori. when product snapShotInfo N/A ', new Date());
            void this.loadSnapShotIdFromProduct();
        }
    };
    private readonly loadSnapShotIdWithSavedDesignRecord = async (recordId: any) => {
        const { context } = this.props;
        if (context.actionContext.requestContext.user.isAuthenticated) {
            //
            recordId = Number(recordId);
            // all saved Design records...
            const savedDesigns: any = await getSavedDesignsAsync({
                callerContext: this.props.context.actionContext,
                queryResultSettings: {}
            });
            // find matched save design...
            const matchedSavedDesign = savedDesigns.Result.find((s: any) => {
                return s.RecId === recordId && s.ProductID === this.state.productId;
            });
            if (matchedSavedDesign) {
                this.setState({ snapShotId: matchedSavedDesign.SnapShotID, isBMAProduct: true, recordId: recordId });
            } else {
                void this.loadSnapShotId();
            }
        } else {
            if (context.actionContext.requestContext.user.signInUrl) {
                window.location.href = context.actionContext.requestContext.user.signInUrl;
            }
        }
    };

    private readonly loadSnapShotIdWithRequestOrderRecord = async (requestOrderId: string | null, lineId: any) => {
        const { context } = this.props;
        if (context.actionContext.requestContext.user.isAuthenticated) {
            const customerInfo = this.props.data.customerInformation.result;
            if (customerInfo && customerInfo.IsB2b) {
                lineId = Number(lineId);
                // all request orders records...
                const response: any = await getRequestOrderAsync(
                    {
                        callerContext: this.props.context.actionContext,
                        queryResultSettings: {}
                    },
                    ''
                );
                // find matched request order...
                const matchedRequestOrder = response.RequestOrder.find((r: any) => {
                    return r.RequestOrderId === requestOrderId && r.LineNum === lineId;
                });
                if (matchedRequestOrder) {
                    this.setState({
                        snapShotId: matchedRequestOrder.Snapshotid,
                        isBMAProduct: true,
                        requestOrderId: matchedRequestOrder.RequestOrderId,
                        lineId: matchedRequestOrder.LineNum
                    });
                } else {
                    void this.loadSnapShotId();
                }
            } else {
                if (context.actionContext.requestContext.user.signInUrl) {
                    window.location.href = context.actionContext.requestContext.user.signInUrl;
                }
            }
        } else {
            if (context.actionContext.requestContext.user.signInUrl) {
                window.location.href = context.actionContext.requestContext.user.signInUrl;
            }
        }
    };
    private readonly loadSnapShotIdWithwishListItem = async (wishListItemSnapShotId: string | null, lineId: string | null) => {
        const { context } = this.props;
        if (context.actionContext.requestContext.user.isAuthenticated) {
            const wishlists = await getByCustomerAsync({ callerContext: this.props.context.actionContext, queryResultSettings: {} }, null);
            if (wishlists && wishlists.length > 0) {
                const extensionPropertiesSnapShotId: any = [];
                wishlists.forEach(currWishlist => {
                    if (currWishlist.CommerceListLines) {
                        currWishlist.CommerceListLines.forEach((commerceListLine: CommerceListLine) => {
                            if (commerceListLine.ExtensionProperties && commerceListLine.ExtensionProperties.length > 0) {
                                const snapShotId = commerceListLine.ExtensionProperties.find(e => {
                                    return e.Key === 'AAA_SNAPSHOTID';
                                });
                                if (snapShotId && snapShotId.Value && snapShotId.Value.StringValue) {
                                    extensionPropertiesSnapShotId.push(snapShotId.Value.StringValue);
                                }
                            }
                        });
                        if (extensionPropertiesSnapShotId.length > 0) {
                            const snapShotIdExists = extensionPropertiesSnapShotId.find((snapShotId: string) => {
                                return snapShotId === wishListItemSnapShotId;
                            });
                            if (snapShotIdExists) {
                                // init into product..
                                this.setState({
                                    snapShotId: snapShotIdExists,
                                    lineId: Number(lineId),
                                    isBMAProduct: true
                                });
                            } else {
                                //
                                void this.loadSnapShotId();
                            }
                        } else {
                            //
                            void this.loadSnapShotId();
                        }
                    } else {
                        //
                        void this.loadSnapShotId();
                    }
                });
            } else {
                //
                void this.loadSnapShotId();
            }
        } else {
            if (context.actionContext.requestContext.user.signInUrl) {
                window.location.href = context.actionContext.requestContext.user.signInUrl;
            }
        }
    };

    private readonly getCartLineSnapShotId = (line: any): string | undefined => {
        const snapShotProperty = line?.ExtensionProperties?.find((e: any) => e.Key === 'AAA_SNAPSHOTID');
        return snapShotProperty?.Value?.StringValue;
    };

    private readonly loadSnapShotIdWithCartLineItem = async (cartLineItemSnapShotId: string | null, lineId: string | null) => {
        const { context } = this.props;
        if (!context.actionContext.requestContext.user.isAuthenticated) {
            if (context.actionContext.requestContext.user.signInUrl) {
                window.location.href = context.actionContext.requestContext.user.signInUrl;
            }
            return;
        }

        const cartLines = this.props.data.cart.result?.cart?.CartLines;
        if (!cartLines || cartLines.length === 0 || !cartLineItemSnapShotId) {
            void this.loadSnapShotId();
            return;
        }

        const parsedLineId = Number(lineId);

        // Prefer the exact cart line from the Edit URL (LineNumber + snapshot).
        let matchedLine = cartLines.find((line: any) => {
            return line && line.LineNumber === parsedLineId && this.getCartLineSnapShotId(line) === cartLineItemSnapShotId;
        });

        // Fallback: any cart line with the same snapshot (still restore that design).
        if (!matchedLine) {
            matchedLine = cartLines.find((line: any) => {
                return line && this.getCartLineSnapShotId(line) === cartLineItemSnapShotId;
            });
        }

        if (matchedLine) {
            this.setState({
                snapShotId: this.getCartLineSnapShotId(matchedLine),
                lineId: parsedLineId,
                isBMAProduct: true,
                isUpdateCart: true
            });
            return;
        }

        void this.loadSnapShotId();
    };

    private readonly getContainerIdAndLoadConfigurator = (bridge: any, mode: any) => {
        axios
            .post(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaContainerEndPoint}`, {
                snapshotId: this.state.snapShotId
            })
            .then(containerResponse => {
                // in that case we are ready load Configurator with exist containerId...
                this.setState({ containerId: containerResponse.data.containerId });
                bridge.initContainer(mode, containerResponse.data.containerId);
            })
            .catch(error => {
                console.log(`Call Bma is down when proxy/containers api fail ${this.state.snapShotId}`);
                // in that case we are ready load Configurator with null...
                this.bmaIsDown();
            });
    };

    private readonly configuratorInitialized = async () => {
        const { context } = this.props;
        const customerInfo: any = this.props.context.actionContext.requestContext.user;
        // customerInfo.customerAccountNumber='MAP00045002';
        const bmaConfig: any = this.props.config.bmaConfiguration ? JSON.parse(this.props.config.bmaConfiguration) : '';
        if (!bmaConfig) {
            console.log('bmaConfig', this.props.config);
            this.setState({ bmaConfigurationIsNotValid: true });
            return;
        }
        if (this.metrixConfiguratorInitializedHandler) {
            document.removeEventListener('metrix:configuratorInitialized', this.metrixConfiguratorInitializedHandler);
        }
        this.metrixConfiguratorInitializedHandler = (ev: any) => {
            this.bmaIsUp();
            const bridge = ev.detail.bridge;
            bridge.addLanguages(['de', 'en']);
            bridge.currentLanguage = 'en';
            if (bmaConfig.context) {
                bridge.setContextValue('cartMode', bmaConfig.context.cartMode);
            }
            const mode = bridge.integration.mode('configurator');
            void this.getContainerIdAndLoadConfigurator(bridge, mode);
            bridge.listen('containerChanged', (ev: any) => {
                const detail = ev.detail;
                console.log(`container changed: ${detail.containerId}`);
                this.setState({ mode: 'init' });
                // ---
                // here you can save the new ID to Session, Cookie, Memory, ...
                // ---
            });
            bridge.listen('containerUpdated', (ev: any) => {
                var detail = ev.detail;
                console.log(`container updated: ${detail.containerId}`);
                if (this.state.mode === 'init') {
                    this.setState({ mode: 'update', containerId: detail.containerId });
                } else if (this.state.mode === 'update') {
                    this.setState({ changesSaved: true, containerId: detail.containerId });
                }
            });
            bridge.listen('buttonClicked', (ev: any) => {
                console.log(`Button clicked:${ev.detail.button}`);
                if (context.actionContext.requestContext.user.isAuthenticated) {
                    if (ev.detail.button === bmaConfig.action.order) {
                        if (customerInfo.isB2b) {
                            if (this.state.isUpdateCart) {
                                void this.updateCart();
                            } else {
                                void this.addToCart();
                            }
                        } else if (!customerInfo.isB2b) {
                            void this.addToB2CCart();
                        }
                    } else if (!customerInfo.isB2b && ev.detail.button === bmaConfig.action.saveDesign) {
                        // void this.addToSaveDesignList();
                        void this.addToOrderRequestList();
                    } else if (customerInfo.isB2b && ev.detail.button === bmaConfig.action.saveDesign) {
                        void this.addToSaveDesignList();
                    }
                } else {
                    void this.setCookieAndRedirectToSignIn();
                }
            });
            bridge.listen('stepChanged', function(ev: any) {
                // here you can see what is the active step in the UI, maybe important if the info video should be different for each step
                console.log(ev.detail);
            });
        };
        document.addEventListener('metrix:configuratorInitialized', this.metrixConfiguratorInitializedHandler);
        let stockistId: any;
        console.log('customer Info', customerInfo);
        if (customerInfo && customerInfo.customerAccountNumber) {
            if (customerInfo.isB2b) {
                //
                const data = await getBMAStockistAsync({ callerContext: this.props.context.actionContext });
                this.setState({ bmaRetailStockistInfo: data });
                stockistId = data.BMARetailStockist;
                console.log('stockistIdForB2B', stockistId);
            } else {
                const data = await getB2BCustomerIdAsync(
                    { callerContext: this.props.context.actionContext },
                    customerInfo.customerAccountNumber
                );
                this.setState({ bmaRetailStockistInfo: data });
                stockistId = data.BMARetailStockist;
                console.log('stockistIdForB2c', stockistId);
            }
        } else {
            //script.src = this.props.config.bmaScript ? `${this.props.config.bmaScript}?jewelerId=` : '';
            stockistId = '';
        }
        if (window['bootstrapMetrixModule']) {
            console.log('stockistId', stockistId);
            window['bootstrapMetrixModule']({
                jewelerId: stockistId
            });
        } else {
            setTimeout(() => {
                console.log('Call form set time for bootstrapMetrixModule existence');
                if (window['bootstrapMetrixModule']) {
                    window['bootstrapMetrixModule']({
                        jewelerId: stockistId
                    });
                } else {
                    console.log('Call bma is down when bootstrapMetrixModule is not present in window');
                    this.bmaIsDown();
                }
            }, this.props.config.ringConfiguratorOfflineTimeout);
        }
        if (!this.hasRegisteredSignInListener) {
            this.hasRegisteredSignInListener = true;
            window.addEventListener('signInEvent', () => {
                console.log('signInEventListner');
                void this.setCookieAndRedirectToSignIn();
            });
        }
    };

    public componentWillUnmount(): void {
        if (this.metrixConfiguratorInitializedHandler) {
            document.removeEventListener('metrix:configuratorInitialized', this.metrixConfiguratorInitializedHandler);
            this.metrixConfiguratorInitializedHandler = undefined;
        }
    }

    private readonly addToOrderRequestList = async () => {
        const { context } = this.props;
        const customerInfo: any = this.props.data.customerInformation.result;
        const customerId = customerInfo.AccountNumber;
        const snapShot = await axios.post(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaSnapshotEndPoint}`, {
            containerId: this.state.containerId
        });
        if (snapShot.data.snapshotId) {
            let bmaPriceEndPoint = this.props.app.config.bmaPriceEndPoint.replace('#snapshotId', snapShot.data.snapshotId);
            bmaPriceEndPoint = bmaPriceEndPoint.replace('#jewellerId', this.state.bmaRetailStockistInfo.BMARetailStockist);
            const price = await axios.get(`${this.props.app.config.bmaBaseUrl}${bmaPriceEndPoint}`);
            const addLinesData = {
                CommerceListId: 1234567,
                ProductId: this.state.productId,
                CustomerId: customerId,
                ExtensionProperties: [
                    {
                        Key: 'AAA_SNAPSHOTID',
                        Value: {
                            StringValue: snapShot.data.snapshotId
                        }
                    },
                    {
                        Key: 'AAA_B2CPRICE',
                        Value: {
                            DecimalValue: customerInfo.IsB2b ? 0 : price.data.sum.vk
                        }
                    },
                    {
                        Key: 'AAA_B2BPRICE',
                        Value: {
                            DecimalValue: customerInfo.IsB2b ? price.data.sum.vk : 0
                        }
                    }
                ]
            };
            let createdCommerceList: any;
            if (this.state.lineId) {
                createdCommerceList = await updateCommerceListAsync(
                    { callerContext: context.actionContext },
                    this.state.lineId,
                    snapShot.data.snapshotId
                );
            } else {
                createdCommerceList = await addLinesAsync({ callerContext: context.actionContext }, 1234567, [addLinesData]);
            }
            this.setState({ changesSaved: false, containerId: '', mode: '', isBMAProduct: false });
            this.props.context.request.cookies.set<string>('snapShotInfo', '');
            context.actionContext.update(createGetByCustomerInput({}, null), [createdCommerceList]);
            if (this.props.config.redirectOrderRequestUrl) {
                const request = this.props.context.request;
                let orderRequestUrl = request.url.requestUrl.origin;
                if (request.sitePath) {
                    orderRequestUrl = orderRequestUrl + request.sitePath;
                }
                window.location.href = `${orderRequestUrl}${this.props.config.redirectOrderRequestUrl}`;
            }
        }
    };
    private readonly addToSaveDesignList = async () => {
        const { context } = this.props;
        const customerInfo: any = this.props.data.customerInformation.result;
        const productInfo: any = await getByIdAsync(
            {
                callerContext: this.props.context.actionContext
            },
            this.state.productId,
            this.props.context.actionContext.requestContext.apiSettings.channelId
        );
        const customerId = customerInfo.AccountNumber;
        const snapShot = await axios.post(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaSnapshotEndPoint}`, {
            containerId: this.state.containerId
        });
        if (snapShot.data.snapshotId) {
            let bmaPriceEndPoint = this.props.app.config.bmaPriceEndPoint.replace('#snapshotId', snapShot.data.snapshotId);
            bmaPriceEndPoint = bmaPriceEndPoint.replace('#jewellerId', this.state.bmaRetailStockistInfo.BMARetailStockist);
            const price = await axios.get(`${this.props.app.config.bmaBaseUrl}${bmaPriceEndPoint}`);
            const addLinesData = {
                CustomerID: customerId,
                Name: customerInfo.Name,
                Quantity: 1,
                ProductID: this.state.productId,
                UnitOfMeasure: productInfo.DefaultUnitOfMeasure,
                SnapShotID: snapShot.data.snapshotId,
                B2CPrice: customerInfo.IsB2b ? 0 : price.data.sum.vk,
                B2BPrice: customerInfo.IsB2b ? price.data.sum.vk : 0
            };
            this.setState({ changesSaved: false });
            await createSavedDesignsAsync({ callerContext: context.actionContext }, [addLinesData]);
            this.togglePopUp();
        }
    };
    private readonly addToCart = async () => {
        const { context, data } = this.props;
        let cart: Readonly<any> = {};
        if (data && data.cart && data.cart.result) {
            console.log('cart', data.cart.result.cart);
            cart = data.cart.result.cart;
        }

        const product: any = await getByIdAsync(
            {
                callerContext: context.actionContext
            },
            this.state.productId,
            context.actionContext.requestContext.apiSettings.channelId
        );
        if (cart.Id) {
            const snapShot = await axios.post(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaSnapshotEndPoint}`, {
                containerId: this.state.containerId
            });
            if (snapShot.data.snapshotId) {
                let bmaPriceEndPoint = this.props.app.config.bmaPriceEndPoint.replace('#snapshotId', snapShot.data.snapshotId);
                bmaPriceEndPoint = bmaPriceEndPoint.replace('#jewellerId', this.state.bmaRetailStockistInfo.BMARetailStockist);
                const price = await axios.get(`${this.props.app.config.bmaBaseUrl}${bmaPriceEndPoint}`);
                // generate order reference...
                const weekday = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

                const d = new Date();
                const day = weekday[d.getDay()];
                const year = new Date()
                    .getFullYear()
                    .toString()
                    .substr(-2);
                const oneDigitRandomNumber = Math.floor(1 + Math.random() * 9);
                const fourDigitRandomNumber = Math.floor(1000 + Math.random() * 9000);
                // eslint-disable-next-line radix
                let priceInFloat = parseInt(price.data.sum.vk).toString();
                priceInFloat = priceInFloat.padStart(4, '0');
                const referenceNumber = `${day}${year}-${oneDigitRandomNumber}${priceInFloat}-${fourDigitRandomNumber}`;
                const addCartLines = {
                    CatalogId: context.request.apiSettings.catalogId,
                    Description: product.Description,
                    EntryMethodTypeValue: 3,
                    ItemId: product.ItemId,
                    ProductId: product.RecordId,
                    IsPriceKeyedIn: true,
                    Quantity: 1,
                    TrackingId: '',
                    UnitOfMeasureSymbol: product.DefaultUnitOfMeasure,
                    IsGiftCardLine: false,
                    Price: price.data.sum.vk,
                    ExtensionProperties: [
                        {
                            Key: 'AAA_SNAPSHOTID',
                            Value: {
                                StringValue: snapShot.data.snapshotId
                            }
                        },
                        {
                            Key: 'AAA_REFERENCENUMBER',
                            Value: {
                                StringValue: referenceNumber
                            }
                        }
                    ]
                };
                if (this.state.requestOrderId) {
                    const requestOrderId: any = {
                        Key: 'AAA_REQUESTORDERID',
                        Value: {
                            StringValue: this.state.requestOrderId
                        }
                    };
                    const lineId: any = {
                        Key: 'AAA_REQUESTORDERLINENUM',
                        Value: {
                            DecimalValue: this.state.lineId
                        }
                    };
                    addCartLines.ExtensionProperties.push(requestOrderId);
                    addCartLines.ExtensionProperties.push(lineId);
                }
                await addCartLinesAsync(
                    { callerContext: this.props.context.actionContext, queryResultSettings: {} },
                    cart.Id,
                    [addCartLines],
                    cart.Version
                );
                this.setState({
                    changesSaved: false,
                    containerId: '',
                    mode: '',
                    isBMAProduct: false,
                    requestOrderId: '',
                    lineId: ''
                });
                this.props.context.request.cookies.set<string>('snapShotInfo', '');
                if (this.props.config.redirectRequestOrderActionUrl) {
                    const request = this.props.context.request;
                    let requestOrderActionUrl = request.url.requestUrl.origin;
                    if (request.sitePath) {
                        requestOrderActionUrl = requestOrderActionUrl + request.sitePath;
                    }
                    window.location.href = `${requestOrderActionUrl}${this.props.config.redirectRequestOrderActionUrl}`;
                }
            }
        }
    };

    private readonly updateCart = async () => {
        const { data } = this.props;
        let cart: Readonly<any> = {};
        if (data && data.cart && data.cart.result) {
            console.log('cart', data.cart.result.cart);
            cart = data.cart.result.cart;
        }

        // const product: any = await getByIdAsync(
        //     {
        //         callerContext: context.actionContext
        //     },
        //     this.state.productId,
        //     context.actionContext.requestContext.apiSettings.channelId
        // );
        if (cart.Id) {
            const snapShot = await axios.post(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaSnapshotEndPoint}`, {
                containerId: this.state.containerId
            });
            if (snapShot.data.snapshotId) {
                let bmaPriceEndPoint = this.props.app.config.bmaPriceEndPoint.replace('#snapshotId', snapShot.data.snapshotId);
                bmaPriceEndPoint = bmaPriceEndPoint.replace('#jewellerId', this.state.bmaRetailStockistInfo.BMARetailStockist);
                const price = await axios.get(`${this.props.app.config.bmaBaseUrl}${bmaPriceEndPoint}`);
                // generate order reference...
                const weekday = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

                const d = new Date();
                const day = weekday[d.getDay()];
                const year = new Date()
                    .getFullYear()
                    .toString()
                    .substr(-2);
                const oneDigitRandomNumber = Math.floor(1 + Math.random() * 9);
                const fourDigitRandomNumber = Math.floor(1000 + Math.random() * 9000);
                // eslint-disable-next-line radix
                let priceInFloat = parseInt(price.data.sum.vk).toString();
                priceInFloat = priceInFloat.padStart(4, '0');
                const referenceNumber = `${day}${year}-${oneDigitRandomNumber}${priceInFloat}-${fourDigitRandomNumber}`;
                const cartState: any = await getCartState(this.props.context.actionContext);
                const updatedCartLines = cartState.cart.CartLines?.map((cartLineItem: any) => {
                    if (this.state.lineId === cartLineItem.LineNumber) {
                        cartLineItem.ExtensionProperties.map((cartEP: any) => {
                            if (cartEP.Key === 'AAA_SNAPSHOTID') {
                                cartEP.Value = {
                                    StringValue: snapShot.data.snapshotId
                                };
                                return cartEP;
                            }
                            if (cartEP.Key === 'AAA_REFERENCENUMBER') {
                                cartEP.Value = {
                                    StringValue: referenceNumber
                                };
                                return cartEP;
                            }
                            return cartEP;
                        });
                        cartLineItem.Price = price.data.sum.vk;
                        return cartLineItem;
                    }
                    return cartLineItem;
                });
                await updateCartLinesAsync(
                    { callerContext: this.props.context.actionContext, queryResultSettings: {} },
                    cart.Id,
                    updatedCartLines
                );
                this.setState({
                    changesSaved: false,
                    containerId: '',
                    mode: '',
                    isBMAProduct: false,
                    requestOrderId: '',
                    lineId: ''
                });
                this.props.context.request.cookies.set<string>('snapShotInfo', '');
                if (this.props.config.redirectRequestOrderActionUrl) {
                    const request = this.props.context.request;
                    let requestOrderActionUrl = request.url.requestUrl.origin;
                    if (request.sitePath) {
                        requestOrderActionUrl = requestOrderActionUrl + request.sitePath;
                    }
                    window.location.href = `${requestOrderActionUrl}${this.props.config.redirectRequestOrderActionUrl}`;
                }
            }
        }
    };

    private readonly addToB2CCart = async () => {
        const { context } = this.props;

        const product: any = await getByIdAsync(
            {
                callerContext: context.actionContext
            },
            this.state.productId,
            context.actionContext.requestContext.apiSettings.channelId
        );
        if (product) {
            const snapShot = await axios.post(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaSnapshotEndPoint}`, {
                containerId: this.state.containerId
            });
            if (snapShot.data.snapshotId) {
                const addCartLines = {
                    BMASnapshotId: snapShot.data.snapshotId,
                    ItemId: product.ItemId,
                    ProductId: product.RecordId
                };
                await createB2CCartServiceAsync({ callerContext: this.props.context.actionContext }, [addCartLines]);
                window.dispatchEvent(this.addEvent);
                this.setState({
                    changesSaved: false,
                    containerId: '',
                    mode: '',
                    isBMAProduct: false,
                    requestOrderId: '',
                    lineId: ''
                });
                this.props.context.request.cookies.set<string>('snapShotInfo', '');
                const request = this.props.context.request;
                let cartUrl = request.url.requestUrl.origin;
                if (request.sitePath) {
                    cartUrl = cartUrl + request.sitePath;
                }
                window.location.href = `${cartUrl}/cart`;
            }
        }
    };

    private _renderPopUp = () => {
        if (this.state.showPopUp) {
            this.setState({ changeSaved: false });
        }
        return this.state.showPopUp ? (
            <div
                id='popup1'
                style={{
                    position: 'fixed',
                    top: '50px !important',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    visibility: 'visible',
                    opacity: 1,
                    zIndex: 1000
                }}
            >
                <div
                    style={{
                        margin: '250px auto',
                        background: '#fff',
                        borderRadius: '5px',
                        width: '42%',
                        position: 'relative',
                        transition: 'all 5s ease-in-out',
                        padding: 20,
                        boxShadow: '5px 8px 5px 2px #888888'
                    }}
                >
                    <h2
                        style={{
                            textAlign: 'center',
                            padding: '20px'
                        }}
                    >
                        {this.props.config.savedDesignPopUpContent}
                    </h2>
                    <div>
                        <span style={{ padding: '5px' }}>
                            <a
                                onClick={() => {
                                    this.togglePopUp();
                                }}
                            >
                                {' '}
                                <Button className='ms-wishlist-items__product-add-button' title={''}>
                                    {this.props.config.continueCustomisingButtonText}
                                </Button>
                            </a>
                        </span>
                        <span style={{ padding: '5px' }}>
                            <a onClick={this.redirectToSavedDesign}>
                                {' '}
                                <Button className='ms-wishlist-items__product-add-button' title={''}>
                                    {this.props.config.goToSavedDesignButtonText}
                                </Button>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        ) : null;
    };
    private togglePopUp = () => {
        this.setState({ showPopUp: !this.state.showPopUp });
        this.props.context.request.cookies.set<string>('snapShotInfo', '');
    };

    private redirectToSavedDesign = () => {
        this.setState({ changesSaved: false, containerId: '', mode: '', isBMAProduct: false, showPopup: false });
        this.props.context.request.cookies.set<string>('snapShotInfo', '');
        if (this.props.config.redirectSavedDesignUrl) {
            const request = this.props.context.request;
            let savedDesignUrl = request.url.requestUrl.origin;
            if (request.sitePath) {
                savedDesignUrl = savedDesignUrl + request.sitePath;
            }
            window.location.href = `${savedDesignUrl}${this.props.config.redirectSavedDesignUrl}`;
        }
    };
    private setCookieAndRedirectToSignIn = async () => {
        const snapShot = await axios.post(`${this.props.app.config.bmaBaseUrl}${this.props.app.config.bmaSnapshotEndPoint}`, {
            containerId: this.state.containerId
        });
        console.log('SnapShotId ', snapShot);
        if (snapShot.data.snapshotId) {
            this.props.context.request.cookies.set<any>('snapShotInfo', {
                snapShotId: snapShot.data.snapshotId,
                productId: this.state.productId
            });
            const cSnapShotInfo = this.props.context.request.cookies.get<any>('snapShotInfo');
            console.log('snapShotInfo name ', cSnapShotInfo.name);
            console.log('snapShotInfo status ', cSnapShotInfo.status);
            console.log('snapShotInfo value ', cSnapShotInfo.value);
            console.log('set snapShotId before isConsentGiven in cookie ', new Date());
            if (!this.props.context.request.cookies.isConsentGiven()) {
                this.props.context.request.cookies.setConsentCookie();
            }
            console.log('set snapShotId after isConsentGive in cookie ', new Date());
            const cSnapShotInfo2 = this.props.context.request.cookies.get<any>('snapShotInfo');
            console.log('after isConsentGiven snapShotInfo name ', cSnapShotInfo2.name);
            console.log('after isConsentGiven snapShotInfo status ', cSnapShotInfo2.status);
            console.log('after isConsentGiven snapShotInfo value ', cSnapShotInfo2.value);
            this.setState({ changesSaved: false, containerId: '', mode: '' });
            if (this.props.context.actionContext.requestContext.user.signInUrl) {
                window.location.href = this.props.context.actionContext.requestContext.user.signInUrl;
            }
        } else {
            if (this.props.context.actionContext.requestContext.user.signInUrl) {
                window.location.href = this.props.context.actionContext.requestContext.user.signInUrl;
            }
        }
    };

    private bmaIsDown = () => {
        this.setState({ isBmaDown: true });
    };
    private bmaIsUp = () => {
        this.setState({ isBmaDown: false });
    };
    private ringConfiguratorOfflinePopUp = () => {
        const request = this.props.context.request;
        let categoryPageUrl = request.url.requestUrl.origin;
        if (request.sitePath) {
            categoryPageUrl = categoryPageUrl + request.sitePath;
        }
        const categoryPageActionUrl = `${categoryPageUrl}${
            this.props.config.redirectCategoryPageUrl ? this.props.config.redirectCategoryPageUrl : ''
        }`;
        return this.state.isBmaDown ? (
            <div id='popup1' className={'ring-config-offline-container'}>
                <div className={'ring-config-offline-pop'}>
                    <span
                        className={'remove-icon'}
                        onClick={() => {
                            window.location.href = categoryPageActionUrl;
                        }}
                    >
                        X
                    </span>
                    <h2>{this.props.config.ringConfiguratorOfflineHeading ? this.props.config.ringConfiguratorOfflineHeading : ''}</h2>
                    <div className={'ring-config-offline-pop-content'}>
                        {this.props.config.ringConfiguratorOfflineContent ? this.props.config.ringConfiguratorOfflineContent : ''}
                    </div>
                </div>
            </div>
        ) : null;
    };
    public render(): JSX.Element | null {
        const viewProps: IRingConfiguratorViewProps = {
            ...(this.props as IRingConfiguratorProps<IRingConfiguratorData>),
            _renderPopUp: this._renderPopUp(),
            ringConfiguratorOfflinePopUp: this.ringConfiguratorOfflinePopUp()
        };
        if (this.state.bmaConfigurationIsNotValid) {
            return <>Missing Configuration</>;
        } else {
            return this.state.isBMAProduct ? (this.props.renderView(viewProps) as React.ReactElement) : null;
        }
    }
}

export default RingConfigurator;
